import React from 'react';

const DashboardHome = () => {
	return (
		<div>
			<h1>This is dashboard Home</h1>
		</div>
	);
};

export default DashboardHome;